import { FC } from 'react';
import { MdDelete } from 'react-icons/md';

import { ConfirmationModal } from '@shared/ui/modals';

import { useModal } from '@shared/lib';
import { ITemplate, useDeleteTemplateMutation } from '@entities/template';
import { iconColumnStyle, idColumnStyle, nameColumnStyle, rowStyle } from './TemplateList.tailwind';

type PropsType = ITemplate;

const ListRow: FC<PropsType> = ({ id, templateNumber, templateName }) => {
  const MODAL_TAG = `DELETE_TEMPLATE_${id}_TAG`;

  const { isOpen, handleOpen } = useModal(MODAL_TAG);
  const [deleteTemplateAsync] = useDeleteTemplateMutation();

  const handleDelete = async () => {
    await deleteTemplateAsync(id);
  };

  return (
    <>
      <div className={rowStyle}>
        <span className={idColumnStyle} data-id="span-TemplateNumber">
          {templateNumber}
        </span>
        <p className={nameColumnStyle} data-id="p-TemplateName">
          {templateName}
        </p>
        <div className={iconColumnStyle}>
          <MdDelete onClick={handleOpen} data-id="svg-Delete" />
        </div>
      </div>

      {isOpen ? (
        <ConfirmationModal
          title="Confirmation"
          message="Are you sure that you want to delete this file?"
          onConfirm={handleDelete}
        />
      ) : null}
    </>
  );
};

export default ListRow;
